export type ComponentWithChildren = {
  children?: React.ReactNode | React.ReactNode[];
};

export enum DetailsPanelSize {
  XS = 'quarter',
  SMALL = 'third',
  MEDIUM = 'half',
  LARGE = 'twoThirds',
  XL = 'threeQuarters',
  FULL = 'full',
}

export enum Endpoint {
  CAR_SHARING = 'carSharing',
  CONNECTED_SERVICE = 'connectionService',
}

export enum VerificationType {
  CAR_SHARING = 'CAR_SHARING',
  IDENTITY_VERIFICATION = 'IDENTITY_VERIFICATION',
}

export type VerificationScope = VerificationType | 'ALL';

export type ApplicantQuery = {
  caseId: string;
  customerNumber: string;
};

export type DefinitionDetails = ComponentWithChildren & {
  label: string;
};
